import { CrewClaimResolutionMethodEnum } from 'corso-types';

import { useClaim } from '~/features/claimReview/ClaimReviewProvider';
import { ClaimLineItemCard } from './ClaimLineItemCard';

export default function ClaimLineItemList() {
  const claim = useClaim();

  // sort claim line items to make requested as replacement order come first, in Shop Now scenarios we always want to show the replacement order first
  const sortedClaimLineItems = [...claim.claimLineItems].sort((a) =>
    a.requestedResolutionMethodEnum ===
    CrewClaimResolutionMethodEnum.replacementOrder
      ? -1
      : 1,
  );

  return (
    <>
      {sortedClaimLineItems.map((claimLineItem) => (
        <ClaimLineItemCard
          key={claimLineItem.id}
          claimLineItem={claimLineItem}
        />
      ))}
    </>
  );
}
